import { Button } from '@ghq-abi/design-system-v2';
import { useTranslate } from '@tolgee/react';

import { useFullscreen } from '~/contexts/FullscreenContext';

import { Icon } from '../Icon';

export function FullScreenActivate({ disabled }: { disabled?: boolean }) {
  const { t } = useTranslate();

  const fullscreen = useFullscreen();

  return (
    <Button
      iconLeft={<Icon isCustom icon="fullScreenActive" />}
      variant="secondary"
      size="md"
      onClick={fullscreen.activate}
      title={t('actions.activate', { t: t('common.fullscreen') })}
      disabled={disabled}
      aria-label={t('common.fullscreen')}
    >
      {t('common.fullscreen')}
    </Button>
  );
}
